module.exports = __webpack_public_path__ + "img/agent-role.e6958f6c.webp";